/* eslint-disable react/prop-types */
import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#3778C2';

const styles = StyleSheet.create({
	row: {
		flexDirection: 'row',
		alignItems: 'center',
		minHeight: 40,
	},

	cell: {
		fontSize: 8,
		padding: 5,
		borderRightWidth: 1,
		borderRightColor: borderColor,
		justifyContent: 'center',
	},

	id: { width: '8%', textAlign: 'center', borderLeftWidth: 1, borderLeftColor: borderColor,height:'100%' },
	name: { width: '20%', textAlign: 'left',height:'100%' },
	allocation: { width: '30%', textAlign: 'left',height:'100%' },
	coverage: { width: '12%', textAlign: 'center' ,height:'100%'},
	date: { width: '30%', textAlign: 'center', borderRightWidth: 1,height:'100%' },

	endborder: {
		borderBottomColor: borderColor,
		borderBottomWidth: 1,
		width: '100%',
	}
});

const InvoiceTableRow = (props) => {
	const rows = props.data?.map((item, index) => (
		<View key={index} wrap={false}>
      
			<View style={styles.row}>
				<Text style={[styles.cell, styles.id]}>{index + 1}</Text>

				<Text style={[styles.cell, styles.name]}>
					{item.name}
				</Text>

				<Text style={[styles.cell, styles.allocation]}>
					{item.allocation}
				</Text>

				<Text style={[styles.cell, styles.coverage]}>
					{item.coverage}
				</Text>

				<Text style={[styles.cell, styles.date]}>
					{new Date(item.date).toLocaleString()}
				</Text>
			</View>

			<View style={styles.endborder} />
		</View>
	));

	return <>{rows}</>;
};

export default InvoiceTableRow;